import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Lock, User, AlertCircle } from 'lucide-react';
import '../styles/Admin.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('mstechs_token');
    if (token) {
      verifyToken(token);
    }
  }, []);

  const verifyToken = async (token) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/verify`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        navigate('/mstechs/dashboard');
      }
    } catch (err) {
      localStorage.removeItem('mstechs_token');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('mstechs_token', data.token);
        navigate('/mstechs/dashboard');
      } else {
        setError(data.message || 'Greška pri prijavi');
      }
    } catch (err) {
      setError('Greška pri povezivanju sa serverom');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrapper">
      <div className="admin-login-bg">
        <div className="admin-login-shape shape-1"></div>
        <div className="admin-login-shape shape-2"></div>
        <div className="admin-login-shape shape-3"></div>
      </div>
      
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <div className="admin-logo">
              <span className="logo-text">MS</span>
              <span className="logo-accent">Tech</span>
            </div>
            <h1>Admin Panel</h1>
            <p>Prijavite se za pristup</p>
          </div>

          <form onSubmit={handleSubmit} className="admin-login-form">
            {error && (
              <div className="admin-error">
                <AlertCircle size={18} />
                <span>{error}</span>
              </div>
            )}

            <div className="admin-input-group">
              <label htmlFor="username">Korisničko ime</label>
              <div className="admin-input-wrapper">
                <User size={20} className="admin-input-icon" />
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Unesite korisničko ime"
                  required
                />
              </div>
            </div>

            <div className="admin-input-group">
              <label htmlFor="password">Lozinka</label>
              <div className="admin-input-wrapper">
                <Lock size={20} className="admin-input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Unesite lozinku"
                  required
                />
                <button
                  type="button"
                  className="admin-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <button type="submit" className="admin-login-btn" disabled={loading}>
              {loading ? 'Prijava...' : 'Prijavite se'}
            </button>
          </form>

          <div className="admin-login-footer">
            <p>© {new Date().getFullYear()} MS Tech</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;